@if (content) {
<!-- Close Button -->
<a class="pos-absolute top-5 right-5 z-2"
   [routerLink]="'/account/my-missions'">
    <i class="icon-close"></i>
</a>

<!-- Carousel Dots -->
<div class="_swiperPagination"></div>
<div class="flex-grow overflow-hidden">
    <!-- Carousel -->
    <carousel class="_profileMissionCarousel"
              [pagination]="{
                            el: '._swiperPagination',
                            clickable: false
                        }"
              [slidesPerView]="1"
              [allowTouchMove]="false"
              (afterInit)="onAfterSwiperInit($event)"
              (slideChange)="onSlideChange($event)">

        <!-- Slide 1: Let's Start -->
        <ng-template swiperSlide>
            <form #slide1Form="ngForm"
                  class="flex-column wrap">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 0 }"></ng-container>

                <!-- Location Field -->
                <p class="s2 m-b-2 m-t-5">{{'Where do you live?' | translate}}</p>
                <input-wrap>
                    <select class="select"
                            name="location"
                            [muiInput]="'Country' | translate"
                            [(ngModel)]="profileData.customer!.location">
                        <option value="">{{'Select country' | translate}}</option>
                        @for (country of countries | orderBy: ['name'] | pushCountriesToFront; track $index) {
                        @if (country.code !== 'divider') {
                        <option [value]="country.code">{{country.name}}</option>
                        }
                        @if (country.code === 'divider') {
                        <option [value]="undefined"
                                disabled="disabled">----------------</option>
                        }
                        }
                    </select>
                </input-wrap>

                <!-- Profile Image -->
                <profile-image class="block m-t-5"
                               [imageRole]="imageRole"
                               [title]="'My profile picture' | translate"
                               [uploadTitle]="'Upload profile picture' | translate"
                               [titleFont]="'s2'"
                               (onFileChange)="onProfileFileChange($event)">
                </profile-image>


                <!-- Buy For Options -->
                <p class="s2 m-t-5">{{'I buy for:' | translate}}</p>
                <input-wrap class="m-t-5 block">
                    <checkbox [name]="'buyForMySelf'"
                              [(ngModel)]="profileData.customer!.buyFor.myself"
                              class="_checkboxPosition">
                        <span class="p1">{{'Myself' | translate}}</span>
                    </checkbox>
                </input-wrap>
                <input-wrap class="m-t-2 block">
                    <checkbox [name]="'buyForMyHorse'"
                              [(ngModel)]="profileData.customer!.buyFor.myselfHorse"
                              class="_checkboxPosition">
                        <span class="p1">{{'My horse' | translate}}</span>
                    </checkbox>
                </input-wrap>
                <input-wrap class="m-t-2 block">
                    <checkbox [name]="'buyForChildren'"
                              [(ngModel)]="profileData.customer!.buyFor.children"
                              class="_checkboxPosition">
                        <span class="p1">{{'My child or grandchild' | translate}}</span>
                    </checkbox>
                </input-wrap>
                <input-wrap class="m-t-2 block">
                    <checkbox [name]="'buyForChildrenHorse'"
                              [(ngModel)]="profileData.customer!.buyFor.childrenHorse"
                              class="_checkboxPosition">
                        <span class="p1">{{"My child or grandchild's horse" | translate}}</span>
                    </checkbox>
                </input-wrap>
                <input-wrap class="m-t-2 block">
                    <checkbox [name]="'buyForFriend'"
                              [(ngModel)]="profileData.customer!.buyFor.friend"
                              class="_checkboxPosition">
                        <span class="p1">{{'My partner, relatives or friends' | translate}}</span>
                    </checkbox>
                </input-wrap>
                <input-wrap class="m-t-2 block">
                    <checkbox [name]="'buyForFriendHorse'"
                              [(ngModel)]="profileData.customer!.buyFor.friendHorse"
                              class="_checkboxPosition">
                        <span class="p1">{{"Partner, relative or friends' horse" | translate}}</span>
                    </checkbox>
                </input-wrap>

                <action class="w-12 m-t-11 button"
                        [status]="saveStatus"
                        (click)="nextSlide(slide1Form, profileImage)">
                    <span *iCms="'saveButtonText' of getSlideContent(0)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </form>
        </ng-template>

        <!-- Slide 2: Tell Us About You -->
        <ng-template swiperSlide>
            <form #slide2Form="ngForm"
                  class="flex-column wrap p-b-5">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 1 }"></ng-container>

                @if (profileFormSettings?.sizeGroups) {
                <!-- Size Selector -->
                <profile-size-selector class="block m-t-13"
                                       [sizeGroups]="profileFormSettings!.sizeGroups"
                                       [(selectedGroup)]="profileData.customer!.sizeGroup"
                                       [(selectedSizes)]="profileData.customer!.sizes!">
                </profile-size-selector>
                }
                <action class="w-12 button m-t-5"
                        [status]="saveStatus"
                        (click)="nextSlide(slide2Form)">
                    <span *iCms="'saveButtonText' of getSlideContent(1)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </form>
        </ng-template>

        <!-- Slide 3: Do You Currently Ride? -->
        <ng-template swiperSlide>
            <form #slide3Form="ngForm"
                  class="flex-column center p-b-5 wrap">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 2 }"></ng-container>

                <p class="p1 m-t-5">{{'Do you currently ride?' | translate}}</p>

                <div class="flex flex-justify-center p-t"
                     style="gap: 16px;">
                    <profile-group-option [minWidth]="'90px'"
                                          [label]="'Yes' | translate"
                                          [selected]="!!profileData.customer!.isRiding"
                                          (click)="profileData.customer!.isRiding = true">
                    </profile-group-option>

                    <profile-group-option [minWidth]="'90px'"
                                          [label]="'No' | translate"
                                          [selected]="!profileData.customer!.isRiding"
                                          (click)="profileData.customer!.isRiding = false">
                    </profile-group-option>
                </div>

                <action class="w-12 button m-t-10"
                        [status]="saveStatus"
                        (click)="nextSlide(slide3Form)">
                    <span *iCms="'saveButtonText' of getSlideContent(2)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </form>
        </ng-template>

        <!-- Slide 4: Disciplines and Competition (only if rides) -->
        <ng-template swiperSlide>
            <form #slide4Form="ngForm"
                  class="flex-column p-b-5 wrap">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 3 }"></ng-container>

                <!-- Disciplines -->
                @if (profileFormSettings?.disciplineOptions && profileFormSettings!.disciplineOptions.length) {
                <p class="p1 m-t-5 center">{{'What disciplines do you take part in?' | translate}}</p>
                <div class="m-t-3 m-l">
                    @for (option of profileFormSettings!.disciplineOptions; track option.value) {
                    <input-wrap class="m-t-2 block">
                        <checkbox [name]="'discipline' + option.value"
                                  [(ngModel)]="profileData.customer!.disciplines[option.value]"
                                  class="_checkboxPosition">
                            <span class="p1">{{option.label | translate}}</span>
                        </checkbox>
                    </input-wrap>
                    }
                    <input-wrap class="m-t-2 block">
                        <checkbox [name]="'discipline-other'"
                                  [(ngModel)]="otherDiscipline"
                                  class="_checkboxPosition">
                            <span class="p1">{{'Other' | translate}}</span>
                        </checkbox>
                    </input-wrap>
                </div>

                @if(otherDiscipline) {
                <input-wrap class="m-t-5 block">
                    <textarea type="textarea"
                              style="height: 54px;"
                              class="input"
                              name="otherDiscipline"
                              [muiInput]="'Other? Tell us more' | translate"
                              [placeholder]="'Type other discipline' | translate"
                              [(ngModel)]="profileData.customer!.otherDiscipline"
                              maxlength="40"></textarea>
                </input-wrap>
                <p class="m-t-2 p3 col-11 right">{{profileData.customer!.otherDiscipline?.length || 0}}/40</p>
                }
                }

                <div class="flex-column flex-middle m-t">
                    <!-- Competition -->
                    <p class="p1 center">{{'Do you compete?' | translate}}</p>
                    <div class="flex flex-wrap flex-justify-center m-t-6"
                         style="gap: 16px; width: fit-content;">
                        <profile-group-option style="width: 47%"
                                              [label]="'Yes - regularly' | translate"
                                              [minWidth]="'100%'"
                                              [selected]="profileData.customer!.compete === ECompeteOptions.regular"
                                              (click)="profileData.customer!.compete = ECompeteOptions.regular">
                        </profile-group-option>
                        <profile-group-option style="width: 47%"
                                              [label]="'Yes - occasionally' | translate"
                                              [minWidth]="'100%'"
                                              [selected]="profileData.customer!.compete === ECompeteOptions.occasional"
                                              (click)="profileData.customer!.compete = ECompeteOptions.occasional">
                        </profile-group-option>
                        <profile-group-option style="width: 47%"
                                              [label]="'No' | translate"
                                              [minWidth]="'100%'"
                                              [selected]="profileData.customer!.compete === ECompeteOptions.no"
                                              (click)="profileData.customer!.compete = ECompeteOptions.no">
                        </profile-group-option>
                    </div>
                </div>

                <action class="w-12 button m-t-10"
                        [status]="saveStatus"
                        (click)="nextSlide(slide4Form)">
                    <span *iCms="'saveButtonText' of getSlideContent(3)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </form>
        </ng-template>

        <!-- Slide 5: Do You Own a Horse? -->
        <ng-template swiperSlide>
            <form #slide5Form="ngForm"
                  class="flex-column center p-b-5 wrap">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 4 }"></ng-container>

                <p class="p1 m-t-5">{{'Do you own a horse, or have one that you ride regularly?' | translate}}</p>

                <div class="flex flex-justify-center p-t"
                     style="gap: 16px;">
                    <profile-group-option [minWidth]="'90px'"
                                          [label]="'Yes' | translate"
                                          [selected]="!!profileData.customer!.isHorseOwner"
                                          (click)="profileData.customer!.isHorseOwner = true">
                    </profile-group-option>

                    <profile-group-option [minWidth]="'90px'"
                                          [label]="'No' | translate"
                                          [selected]="!profileData.customer!.isHorseOwner"
                                          (click)="profileData.customer!.isHorseOwner = false">
                    </profile-group-option>
                </div>

                <action class="w-12 button m-t-10"
                        [status]="saveStatus"
                        (click)="nextSlide(slide5Form)">
                    <span *iCms="'saveButtonText' of getSlideContent(4)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </form>
        </ng-template>

        <!-- Slide 6: Horse Profile (only if owns horse) -->
        <ng-template swiperSlide>
            <form #slide6Form="ngForm"
                  class="flex-column p-b-5 wrap overflow-hidden">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 5 }"></ng-container>

                <!-- Horse Name -->
                <input-wrap class="block m-t-10"
                            [required]="true"
                            [label]="'What\'s your horse\'s name?' | translate">
                    <input type="text"
                           class="input"
                           name="horseName"
                           required
                           [placeholder]="'Horse name' | translate"
                           [(ngModel)]="profileData.horses![0].name"
                           maxlength="100" />
                </input-wrap>

                <!-- Horse Breeding -->
                @if (profileFormSettings?.breedingOptions && profileFormSettings!.breedingOptions.length) {
                <div class="m-t-10">
                    <p class="label m-b-2">{{'What breed is your horse?' | translate}}</p>
                    <input-wrap>
                        <select class="input"
                                name="horseBreeding"
                                [muiInput]="'Select breed' | translate"
                                [(ngModel)]="profileData.horses![0].breeding">
                            @for (option of profileFormSettings!.breedingOptions; track option.value) {
                            <option [value]="option.value">{{option.label}}</option>
                            }
                        </select>
                    </input-wrap>
                </div>
                }

                <!-- Horse Height -->
                <input-wrap class="block m-t-10"
                            [label]="'What height is your horse?' | translate">
                    <input type="number"
                           class="input"
                           name="horseHeight"
                           [placeholder]="'Horse height' | translate"
                           [(ngModel)]="profileData.horses![0].height"
                           maxlength="50" />
                </input-wrap>


                <div class="m-t-10">
                    <horse-color-selector [(selectedColor)]="profileData.horses![0].colour"
                                          [title]="'What colour is your horse?'"
                                          [attributeCode]="'horse_colour'">
                    </horse-color-selector>
                </div>

                <p class="m-t-10 label m-b-2">{{'What\'s your horse\'s date of birth?' | translate}}</p>
                <!-- Date of Birth -->
                <input-wrap class="block">
                    <input type="date"
                           class="input"
                           name="horseDob"
                           [muiInput]="'Date of birth'| translate"
                           [(ngModel)]="horseDob"
                           validateDobRange>
                </input-wrap>

                <profile-image class="block m-t-5"
                               [imageRole]="horseImageRole"
                               [index]="0"
                               [title]="'My horse picture' | translate"
                               [uploadTitle]="'Upload a picture of your horse' | translate"
                               (onFileChange)="onHorseFileChange($event)">
                </profile-image>


                @if (profileFormSettings?.horseSizeTypes && profileFormSettings!.horseSizeTypes.length) {
                <div class="m-t-10">
                    @for (type of profileFormSettings!.horseSizeTypes; track type.title) {
                    <profile-size-options class="block m-t"
                                          [sizeType]="type"
                                          [(value)]="profileData.horses![0].sizes[type.title]">
                    </profile-size-options>
                    }
                </div>
                }

                <action class="w-12 button m-t-10"
                        [status]="saveStatus"
                        (click)="nextSlide(slide6Form, undefined, horseImage)">
                    <span *iCms="'saveButtonText' of getSlideContent(5)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </form>
        </ng-template>

        <!-- Slide 7: Favourite Colors -->
        <ng-template swiperSlide>
            <div class="flex-column center p-b-5 wrap">
                <ng-container *ngTemplateOutlet="slideHeaderTpl; context: { index: 6 }"></ng-container>

                @if (profileFormSettings?.favouriteColourOptions) {
                <!-- Color Selector -->
                <div class="w-12 m-t-5">
                    <profile-color-selector [colorOptions]="profileFormSettings!.favouriteColourOptions"
                                            [(selectedColors)]="profileData.customer!.favouriteColours"
                                            [attributeCode]="colourAttributeCode">
                    </profile-color-selector>

                    <!-- Buy For Options -->
                    <p class="s1 m-t-8 left">{{'How do you style your outfits?' | translate}}</p>
                    <radio-group name="styleOutfits"
                                 [(ngModel)]="profileData.customer!.styleOutfits">
                        <radio [value]="'matchyMatchy'"
                               class="block left _outfitRadio m-t-5 w-12">
                            <span class="p1">{{'Matchy matchy - I like to wear one colour head to foot' |
                                translate}}</span>
                        </radio>
                        <radio [value]="'mixyMatchy'"
                               class="block left _outfitRadio m-t-2 w-12">
                            <span class="p1">{{'Mixy matchy - I wear two or more colours together' |
                                translate}}</span>
                        </radio>
                        <radio [value]="'unsure'"
                               class="block left _outfitRadio m-t-2 w-12">
                            <span class="p1">{{'Unsure/ none of the above' |
                                translate}}</span>
                        </radio>
                    </radio-group>
                </div>
                }
                <action class="w-12 button m-t-10"
                        [status]="saveStatus"
                        (click)="completeMission()">
                    <span *iCms="'saveButtonText' of getSlideContent(6)"></span>
                </action>
                <result [status]="saveStatus"></result>
            </div>
        </ng-template>

        <!-- Slide 8: Success Screen -->
        <ng-template swiperSlide>
            <mission-success [mission]="mission"
                             [content]="content"
                             class="height-100 p-r-8 p-l-8 m-t">
            </mission-success>
        </ng-template>
    </carousel>
</div>
}

<ng-template #slideHeaderTpl
             let-index="index">
    <div class="flex flex-justify-center">
        <div class="bg-col-w b-radius-max box-shadow-1 m-t-3">
            <i [ngClass]="getSlideContent(index)?.userIcon"
               class="p-a-2 inline-flex"
               style="font-size: 24px;"></i>
        </div>
    </div>

    <h1 *iCms="'title' of getSlideContent(index)"
        class="h3 m-t-3 center"></h1>
</ng-template>
